export default __webpack_public_path__ + "static/media/exploded-view_labels.169edfb1.png";